import { buildApiUrl } from '../../../config/api';

export type LaunchPromotionResponse = {
  enabled: boolean;
  remaining: number;
  discountPercent: number;
  label: string;
};

export const getLaunchPromotion = async (): Promise<LaunchPromotionResponse> => {
  const url = buildApiUrl('/promotions/launch40');
  const resp = await fetch(url, { method: 'GET' });
  if (!resp.ok) {
    throw new Error(`Failed to fetch launch promotion: ${resp.status} ${resp.statusText}`);
  }
  return (await resp.json()) as LaunchPromotionResponse;
};
